var i = Object.defineProperty, p = Object.defineProperties;
var s = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var l = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable;
var m = (o, e, r) => e in o ? i(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r, a = (o, e) => {
  for (var r in e || (e = {}))
    l.call(e, r) && m(o, r, e[r]);
  if (t)
    for (var r of t(e))
      c.call(e, r) && m(o, r, e[r]);
  return o;
}, f = (o, e) => p(o, s(e));
import h, { forwardRef as y } from "react";
import R from "../lib/SSRBase.mjs";
import d from "../defs/Keyhole.mjs";
const n = y((o, e) => /* @__PURE__ */ h.createElement(R, f(a({ ref: e }, o), { weights: d })));
n.displayName = "Keyhole";
export {
  n as Keyhole
};
